export default "__VITE_ASSET__D0lZeDR5__"